// The entry point imports this first: catalogs are picked when their modules
// load, so the language has to be set before any screen code is imported.
import { bootLanguage } from "./language";

bootLanguage();
